import type { WebExportSettings } from 'gql/__generated__/graphql'

export enum ExportTypeEnumUi {
  SCORM = 'SCORM',
  PDF = 'PDF',
  HTML = 'HTML',
  XAPI = 'XAPI',
  CMI5 = 'CMI5',
}

export enum ManifestIdsTypeEnumUi {
  NEW = 'NEW',
  PREVIOUS = 'PREVIOUS',
  CUSTOM = 'CUSTOM',
}

export enum ExportTargetTypeUiEnum {
  DOWNLOAD = 'DOWNLOAD',
  LMS = 'LMS',
}

export enum ScormFormControlsType {
  EXPORT = 'EXPORT',
  PUBLISH = 'PUBLISH',
  UPDATE = 'UPDATE',
  UPDATE_FORCED = 'UPDATE_FORCED',
}

export enum ExportTypeUi {
  SCORM = 'SCORM',
  PDF = 'PDF',
  HTML = 'HTML',
  MD = 'MD',
  DISPATCH_DOWNLOAD = 'DISPATCH_DOWNLOAD',
  DISPATCH = 'DISPATCH',
  INTEGRATION = 'INTEGRATION',
}

export type WebPackageSettings = WebExportSettings

export const isWebPackageSettings = (settings?: {
  __typename?: string
}): settings is WebPackageSettings => settings?.__typename === 'WebExportSettings'

export type { EnabledSection } from 'gql/__generated__/graphql'
